import { HttpError } from 'modules/http-client'
import { Action } from '../../store'

import { BadgesStateType } from '../../../app/core/services/signalR.service'

type NumericValue = { value: number }

export class DummyAction implements Action {
  readonly type = 'dummy action'
}

export const SIGNALR_ALL_BADGES_INIT = '[signalR] badges init'
export const SIGNALR_ALL_BADGES_INIT_SUCCESS = '[signalR] badges init success'
export const SIGNALR_ALL_BADGES_INIT_FAILURE = '[signalR] badges init failure'

export class AllBadgeInitAction implements Action {
  readonly type = SIGNALR_ALL_BADGES_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class AllBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_ALL_BADGES_INIT_SUCCESS
  constructor(public payload: BadgesStateType) {}
}

export class AllBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_ALL_BADGES_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_GOAL_BADGE_INIT = '[signalR] goal badge init'
export const SIGNALR_GOAL_BADGE_INIT_SUCCESS = '[signalR] goal badge init success'
export const SIGNALR_GOAL_BADGE_INIT_FAILURE = '[signalR] goal badge init failure'

export class GoalBadgeInitAction implements Action {
  readonly type = SIGNALR_GOAL_BADGE_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class GoalBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_GOAL_BADGE_INIT_SUCCESS
  constructor(public payload: number) {}
}

export class GoalBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_GOAL_BADGE_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_FEEDBACK_BADGE_INIT = '[signalR] feedback badge init'
export const SIGNALR_FEEDBACK_BADGE_INIT_SUCCESS = '[signalR] feedback badge init success'
export const SIGNALR_FEEDBACK_BADGE_INIT_FAILURE = '[signalR] feedback badge init failure'

export class FeedbackBadgeInitAction implements Action {
  readonly type = SIGNALR_FEEDBACK_BADGE_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class FeedbackBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_FEEDBACK_BADGE_INIT_SUCCESS
  constructor(public payload: number) {}
}

export class FeedbackBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_FEEDBACK_BADGE_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_REVIEW_BADGE_INIT = '[signalR] review badge init'
export const SIGNALR_REVIEW_BADGE_INIT_SUCCESS = '[signalR] review badge init success'
export const SIGNALR_REVIEW_BADGE_INIT_FAILURE = '[signalR] review badge init failure'

export class ReviewBadgeInitAction implements Action {
  readonly type = SIGNALR_REVIEW_BADGE_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class ReviewBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_REVIEW_BADGE_INIT_SUCCESS
  constructor(public payload: number) {}
}

export class ReviewBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_REVIEW_BADGE_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_TEAM_GOAL_BADGE_INIT = '[signalR] team goal badge init'
export const SIGNALR_TEAM_GOAL_BADGE_INIT_SUCCESS = '[signalR] team goal badge init success'
export const SIGNALR_TEAM_GOAL_BADGE_INIT_FAILURE = '[signalR] team goal badge init failure'

export class TeamGoalBadgeInitAction implements Action {
  readonly type = SIGNALR_TEAM_GOAL_BADGE_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class TeamGoalBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_TEAM_GOAL_BADGE_INIT_SUCCESS
  constructor(public payload: number) {}
}

export class TeamGoalBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_TEAM_GOAL_BADGE_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_MY_TEAM_BADGE_INIT = '[signalR] my team badge init'
export const SIGNALR_MY_TEAM_BADGE_INIT_SUCCESS = '[signalR] my team badge init success'
export const SIGNALR_MY_TEAM_BADGE_INIT_FAILURE = '[signalR] my team badge init failure'

export class MyTeamBadgeInitAction implements Action {
  readonly type = SIGNALR_MY_TEAM_BADGE_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class MyTeamBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_MY_TEAM_BADGE_INIT_SUCCESS
  constructor(public payload: number) {}
}

export class MyTeamBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_MY_TEAM_BADGE_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_TEAM_REVIEW_BADGE_INIT = '[signalR] team review badge init'
export const SIGNALR_TEAM_REVIEW_BADGE_INIT_SUCCESS = '[signalR] team review badge init success'
export const SIGNALR_TEAM_REVIEW_BADGE_INIT_FAILURE = '[signalR] team review badge init failure'

export class TeamReviewBadgeInitAction implements Action {
  readonly type = SIGNALR_TEAM_REVIEW_BADGE_INIT
  /** @param payload personId
   */
  constructor(public payload: number) {}
}

export class TeamReviewBadgeInitSuccessAction implements Action {
  readonly type = SIGNALR_TEAM_REVIEW_BADGE_INIT_SUCCESS
  constructor(public payload: number) {}
}

export class TeamReviewBadgeInitFailureAction implements Action {
  readonly type = SIGNALR_TEAM_REVIEW_BADGE_INIT_FAILURE
  constructor(public payload: HttpError) {}
}

export const SIGNALR_NOTIFICATION_GOAL_COUNT = '[signalR] notification goal count'
export class NotificationGoalCountAction implements Action {
  readonly type = SIGNALR_NOTIFICATION_GOAL_COUNT
  constructor(public payload: NumericValue) {}
}

export const SIGNALR_NOTIFICATION_FEEDBACK_COUNT = '[signalR] notification feedback count'
export class NotificationFeedbackCountAction implements Action {
  readonly type = SIGNALR_NOTIFICATION_FEEDBACK_COUNT
  constructor(public payload: NumericValue) {}
}

export const SIGNALR_NOTIFICATION_REVIEW_COUNT = '[signalR] notification review count'
export class NotificationReviewCountAction implements Action {
  readonly type = SIGNALR_NOTIFICATION_REVIEW_COUNT
  constructor(public payload: NumericValue) {}
}

export const SIGNALR_NOTIFICATION_TEAM_GOAL_COUNT = '[signalR] notification team goal count'
export class NotificationTeamGoalCountAction implements Action {
  readonly type = SIGNALR_NOTIFICATION_TEAM_GOAL_COUNT
  constructor(public payload: NumericValue) {}
}

export const SIGNALR_NOTIFICATION_MY_TEAM_COUNT = '[signalR] notification my team count'
export class NotificationMyTeamCountAction implements Action {
  readonly type = SIGNALR_NOTIFICATION_MY_TEAM_COUNT
  constructor(public payload: NumericValue) {}
}

export const SIGNALR_NOTIFICATION_TEAM_REVIEW_COUNT = '[signalR] notification team review count'
export class NotificationTeamReviewCountAction implements Action {
  readonly type = SIGNALR_NOTIFICATION_TEAM_REVIEW_COUNT
  constructor(public payload: NumericValue) {}
}

type Actions =
  | DummyAction
  | AllBadgeInitAction
  | AllBadgeInitSuccessAction
  | AllBadgeInitFailureAction
  | GoalBadgeInitAction
  | GoalBadgeInitSuccessAction
  | GoalBadgeInitFailureAction
  | ReviewBadgeInitAction
  | ReviewBadgeInitSuccessAction
  | ReviewBadgeInitFailureAction
  | FeedbackBadgeInitAction
  | FeedbackBadgeInitSuccessAction
  | FeedbackBadgeInitFailureAction
  | TeamGoalBadgeInitAction
  | TeamGoalBadgeInitSuccessAction
  | TeamGoalBadgeInitFailureAction
  | MyTeamBadgeInitAction
  | MyTeamBadgeInitSuccessAction
  | MyTeamBadgeInitFailureAction
  | TeamReviewBadgeInitAction
  | TeamReviewBadgeInitSuccessAction
  | TeamReviewBadgeInitFailureAction
  | NotificationGoalCountAction
  | NotificationFeedbackCountAction
  | NotificationReviewCountAction
  | NotificationTeamGoalCountAction
  | NotificationMyTeamCountAction
  | NotificationTeamReviewCountAction

export default Actions



// WEBPACK FOOTER //
// ./src/modules/signal-r/store/signal-r.actions.ts